module.exports = "<p>relations-graph works!</p>\n"